import { watch, type Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export const useFilterPersistence = (storageKey: string, fetchParams: Ref<object>, defaultFilters: () => object) => {
    const router = useRouter();
    const route = useRoute();

    const initializeFilters = () => {
        let filters;

        // gives preference to query, in case the user access the page from a direct link
        if (Object.keys(route.query).length > 0) {
            filters = route.query;
        } else {
            const stored = sessionStorage.getItem(storageKey);

            try {
                filters = stored ? JSON.parse(stored) : null;
            } catch (e) {
                console.error(`Failed to parse stored filters from ${storageKey}:`, e);
                filters = null;
            }
        }

        fetchParams.value = filters && Object.keys(filters).length > 0 ? filters : defaultFilters();
    };

    const syncFiltersToStorage = (newParams: object) => {
        const paramsWithoutCursor = Object.fromEntries(
            Object.entries(newParams).filter(([key, value]) => key !== 'cursor' && value !== '')
        );

        try {
            sessionStorage.setItem(storageKey, JSON.stringify(paramsWithoutCursor));
        } catch (e) {
            console.error(`Failed to save filters to ${storageKey}:`, e);
        }

        router.replace({
            query: paramsWithoutCursor,
        });
    };

    initializeFilters();

    watch(fetchParams, syncFiltersToStorage, { deep: true });
};
